import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "eyeIcon", "eyeOffIcon"]

  toggle() {
    const isPassword = this.inputTarget.type === "password"
    this.inputTarget.type = isPassword ? "text" : "password"

    // Toggle SVG icon visibility
    this.eyeIconTarget.classList.toggle("hidden", isPassword)
    this.eyeOffIconTarget.classList.toggle("hidden", !isPassword)
  }
}
